/* angular:styles/component:css;c2fe5bdd705881d8a4cb6609af7280ced8ca633b5cfef3853d42eba117e75dee;/src/src/app/edge/live/Controller/Evse/pages/schedule/schedule.component.ts */
::ng-deep formly-form {
  height: 100% !important;
}
.schedule-table {
  --ion-grid-padding: 0;
  font-size: 15px;
}
.header-row {
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  padding-bottom: 6px;
  margin-bottom: 4px;
  text-transform: uppercase;
}
.data-row {
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.edit-col ion-button {
  height: 26px;
  font-size: 12px;
}
.chip-repeat,
.chip-controller {
  margin-right: 4px;
  height: 26px;
  font-size: 12px;
}
.repeat-col ion-chip {
  background: #e8f7e8;
}
.controllers-col ion-chip {
  color: #fff;
  font-weight: bold;
}
/*# sourceMappingURL=schedule.component.css.map */
